import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'
import { SITES_SORTS, SitesView, type SitesSort } from '../../../components/group-steering/SitesView'

export type GroupSitesSearch = {
    perimeter?: string
    sort?: SitesSort
}

/** NPS by site (spec 2026-10-02-02). The period comes from the space's shared search. */
export const Route = createFileRoute('/$org/group/sites')({
    component: SitesRoute,
    validateSearch: (search: Record<string, unknown>): GroupSitesSearch => ({
        perimeter: search.perimeter ? String(search.perimeter) : undefined,
        sort: SITES_SORTS.includes(search.sort as SitesSort) ? (search.sort as SitesSort) : undefined,
    }),
})

function SitesRoute() {
    const { org } = Route.useParams()
    const navigate = useNavigate()
    const search = useSearch({ from: '/$org/group/sites' })
    const setSearch = (patch: GroupSitesSearch) =>
        navigate({ to: '/$org/group/sites', params: { org }, search: (prev: Record<string, unknown>) => ({ ...prev, ...patch }) as never, replace: true })
    return (
        <SitesView
            org={org}
            period={search.period ?? '90d'}
            perimeter={search.perimeter}
            sort={search.sort ?? 'answers'}
            onPerimeterChange={(perimeter) => setSearch({ perimeter })}
            onSortChange={(sort) => setSearch({ sort: sort === 'answers' ? undefined : sort })}
        />
    )
}
